<template>
  <div>
    <v-row>
      <v-col sm="11" md="11" lg="11">
        <v-dialog v-model="showCommentsDialog" width="50%" persistent>
          <v-card class="overflow-x-hidden overflow-y-hidden containerbox">
            <v-card-title class="subtitle-2 primary customwhite--text">
              {{ commentDialogHeader }}
              <v-spacer></v-spacer>
              <v-btn outlined class="pa-0 mx-2" dense small title="Close" color="customwhite" @click="closeDialog">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-form ref="commentForm" lazy-validation @submit.prevent="submit">
              <v-row class="px-5 pt-5">
                <v-col cols-12 sm="12" md="12" lg="12">
                  <v-textarea label="Comments / Order Notes" v-model="comments" rows="4" outlined required dense :autofocus="true"
                    :rules="[v => !!v || 'Comments is required']" class="text-xs-left" color="primarytext"></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-divider></v-divider>
            <v-row>
              <v-col sm="12" md="12" lg="12" class="pb-3 text-xs-right pr-5 pb-5 pt-5">
                <v-btn class="ma-2 btn-style float-right" outlined color="secondary" elevation="1" @click="closeDialog">
                  Cancel
                </v-btn>
                <v-btn class="ma-2 btn-style float-right" outlined color="primarytext" elevation="1"
                  @click="onClickSubmitComments">
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'commentsSOComp',
  props: {
    showCommentsDialog: Boolean,
    comments: String,
    commentDialogHeader: String,
    commentId: Number,
  },
  data() {
    return {

    }
  },

  created() {
  },
  mounted() {
  },

  methods: {
    closeDialog() {
      
      this.$emit("close")
      this.$refs.commentForm.resetValidation()
    },
    onClickSubmitComments() {
      if(this.$refs.commentForm.validate()){
      this.$emit("submitComments", this.comments, this.commentId)
      this.closeDialog()}
    },
  },

}
</script>